import { TextField, Box, Typography, Stack, Select, MenuItem, InputLabel, FormControl, Button, IconButton, Checkbox, FormControlLabel } from '@mui/material'
import React, { useEffect, useState } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { axiosGetCall, axiosPatchCall } from 'src/services/apisCall';

import { renderErrorMessage, renderSuccessMessage } from '../../../lib/toastMessage';
import dayjs from 'dayjs';
import { LoadingButton } from '@mui/lab';
import Logger from '../../../lib/Logger';
import Iconify from '../../../components/iconify';

const logger = new Logger("asetting")


const requestList = [
    { label: "Self", value: "U" },
    { label: "Downline", value: "D" },
    { label: "Hierarchy", value: "H" }
]

const CampaignSetting = ({ user }) => {

    const inputSx = {
        color: "grey.900",
        borderColor: 'grey.700',
        borderRadius: "6px",
    };

    const [callLimit, setCallLimit] = useState(0);
    const [apiPerCallLimit, setApiPerCallLimit] = useState(0);
    const [apiContactExistingCustomerForCutting, setApiContactExistingCustomerForCutting] = useState(0);
    const [purgeData, setPurgeData] = useState(false);

    const [callLimitRequestFor, setCallLimitRequestFor] = useState("U");
    const [apiContactExistingCustomerForCuttingRequestFor, setApiContactExistingCustomerForCuttingRequestFor] = useState("U");
    const [purgeDataRequestFor, setPurgeDataRequestFor] = useState("U");

    const [apiPerCallLimitRequestFor, setApiPerCallLimitRequestFor] = useState("U");
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [callLimitLoader, setCallLimitLoader] = useState(false);
    const [apiPerCallLimitLoader, setapiPerCallLimitLoader] = useState(false);
    const [purgeDataCheckLoader, setPurgeDataCheckLoader] = useState(false);
    const [regularCampaignLimit, setRegularCampaignLimit] = useState(0);
    const [regularCampaignLimitRequestFor, setRegularCampaignLimitRequestFor] = useState("U");
    const [regularCampaignLimitLoader, setRegularCampaignLimitLoader] = useState(false);

    const [load, setLoad] = useState(false);

    const updateCallLimit = async () => {
        try {
            setCallLimitLoader(true);
            const payload = {
                userId: user?.voiceInfo?.userId,
                action: "updateCallLimits",
                callLimit,
                requestFor: "U",
            }
            if (user?.voiceInfo?.userType === "reseller") {
                payload.requestFor = callLimitRequestFor;
            }
            await axiosPatchCall("updateProfileSetting", payload);
            setCallLimitLoader(false);

            renderSuccessMessage("Success");
            setLoad((prev) => !prev);
        } catch (error) {
            logger.error(error)
            setCallLimitLoader(false);
            renderErrorMessage(error.message);
        }
    }

    const updateApiContactExistingCustomerForCutting = async () => {
        try {
            setCallLimitLoader(true);
            const payload = {
                userId: user?.voiceInfo?.userId,
                action: "apiContactExistingCustomerForCutting",
                apiContactExistingCustomerForCutting,
                requestFor: "U",
            }
            if (user?.voiceInfo?.userType === "reseller") {
                payload.requestFor = apiContactExistingCustomerForCuttingRequestFor;
            }
            await axiosPatchCall("updateProfileSetting", payload);
            setCallLimitLoader(false);

            renderSuccessMessage("Success");
            setLoad((prev) => !prev);
        } catch (error) {
            logger.error(error)
            setCallLimitLoader(false);
            renderErrorMessage(error.message);
        }
    }

    const updateApiPerCallLimit = async () => {
        try {
            setapiPerCallLimitLoader(true);
            const payload = {
                userId: user?.voiceInfo?.userId,
                action: "updatePerMinuteApiCallLimits",
                apiPerMinuteCallLimit: apiPerCallLimit,
                requestFor: "U",
            }
            if (user?.voiceInfo?.userType === "reseller") {
                payload.requestFor = apiPerCallLimitRequestFor;
            }
            await axiosPatchCall("updateProfileSetting", payload);
            setapiPerCallLimitLoader(false);

            renderSuccessMessage("Success");
            setLoad((prev) => !prev);
        } catch (error) {
            logger.error(error)
            setapiPerCallLimitLoader(false);
            renderErrorMessage(error.message);
        }
    }

    const updatePurgeData = async () => {
        try {
            setPurgeDataCheckLoader(true);
            const payload = {
                userId: user?.voiceInfo?.userId,
                action: "updatePurgeData",
                status: purgeData,
                requestFor: "U",
            }
            if (user?.voiceInfo?.userType === "reseller") {
                payload.requestFor = purgeDataRequestFor;
            }
            await axiosPatchCall("updateProfileSetting", payload);
            setPurgeDataCheckLoader(false);

            renderSuccessMessage("Success");
            setLoad((prev) => !prev);
        } catch (error) {
            logger.error(error)
            setPurgeDataCheckLoader(false);
            renderErrorMessage(error.message);
        }
    }

        const updateRegularCampaignLimit = async () => {
        try {
            setRegularCampaignLimitLoader(true);
            const payload = {
                userId: user?.voiceInfo?.userId,
                action: "regularCampaignLimit",
                regularCampaignLimit: regularCampaignLimit,
                requestFor: "U",
            }
            if (user?.voiceInfo?.userType === "reseller") {
                payload.requestFor = regularCampaignLimitRequestFor;
            }
            await axiosPatchCall("updateProfileSetting", payload);
            setRegularCampaignLimitLoader(false);

            renderSuccessMessage("Success");
            setLoad((prev) => !prev);
        } catch (error) {
            logger.error(error)
            setRegularCampaignLimitLoader(false);
            renderErrorMessage(error.message);
        }
    }

    const handleReset = async (type) => {
        let payload = {
            userId: user?.voiceInfo?.userId,
            action: "resetSetting",
            resetActionType: "",
            requestFor: "U"
        }
        if (type === "callLimit") {
            payload.resetActionType = "updateCallLimits";
            payload.requestFor = callLimitRequestFor;
        }

        if (type === "apiPerCallLimit") {
            payload.resetActionType = "updatePerMinuteApiCallLimits";
            payload.requestFor = apiPerCallLimitRequestFor;
        }
        if (type === "apiContactExistingCustomerForCutting") {
            payload.resetActionType = "apiContactExistingCustomerForCutting";
            payload.requestFor = apiPerCallLimitRequestFor;
        }

        if (type === "updatePurgeData") {
            payload.resetActionType = "updatePurgeData";
            payload.requestFor = purgeDataRequestFor;
        }
        if (type === "regularCampaignLimit") {
            payload.resetActionType = "regularCampaignLimit";
            payload.requestFor = regularCampaignLimitRequestFor;
        }


        try {
            await axiosPatchCall("updateProfileSetting", payload)
            setLoad((prev) => !prev);
        } catch (error) {
            logger.error(error);
            renderErrorMessage(error.message);
        }
    }

    const handleSubmit = async (type) => {
        if (type === "callLimit") {
            await updateCallLimit();
        }

        if (type === "apiPerCallLimit") {
            await updateApiPerCallLimit();
        }

        if (type === "apiContactExistingCustomerForCutting") {
            await updateApiContactExistingCustomerForCutting();
        }

        if (type === "updatePurgeData") {
            await updatePurgeData();
        }
        if (type === "regularCampaignLimit") {
            await updateRegularCampaignLimit();
        }
    }
    function toBoolean(value) {
        return value === "false" || value === false ? false : true;
      }

    const fetchSettingDetails = async () => {
        try {
            const params = { requestUserId: user?.voiceInfo?.userId, requestName: "all" }
            const { data = {} } = await axiosGetCall("getUserSettingsInfo", { ...params });

            const { dailyCallLimit = 0, apiPerMinuteCallLimit = 0, callWindowStartTime = 0, callWindowEndTime = 0, PurgeData, regularCampaignLimit = 0 } = data;

            const currentDate = dayjs();
            const startTime = currentDate.hour(callWindowStartTime).minute(0).second(0).millisecond(0);
            const endTime = currentDate.hour(callWindowEndTime).minute(0).second(0).millisecond(0);

            setCallLimit(parseInt(dailyCallLimit || 0));
            setApiPerCallLimit(parseInt(apiPerMinuteCallLimit || 0));
            setPurgeData(toBoolean(PurgeData));
            setRegularCampaignLimit(parseInt(regularCampaignLimit || 0));
            // setApiContactExistingCustomerForCutting(parseInt(data?.apiContactExistingCustomerForCutting || 0));
            setStartTime(startTime);
            setEndTime(endTime);
        } catch (error) {
            logger.error(error);
        }
    }

    useEffect(() => {
        fetchSettingDetails();
        // eslint-disable-next-line
    }, [load])

    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                    mt: "10px",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        gap: "6px",
                        mb: "15px",
                        border: "0.5px dashed",
                        borderColor: "gray.400",
                        borderRadius: "7px",
                        padding: "12px",
                        paddingTop: "14px"
                    }}
                >
                    <TextField
                        fullWidth
                        id="outlined-basic"
                        label="Enter Call Limit"
                        variant="outlined"
                        InputProps={{
                            sx: inputSx,
                        }}
                        value={callLimit}
                        onChange={(e) => setCallLimit(e.target.value)}
                        size="small"
                    />
                    {user?.voiceInfo?.userType === "reseller" && (
                        <Stack
                            gap={2}
                            direction={"row"}
                            sx={{
                                justifyContent: "center",
                                alignItems: "center",
                                width: "100%",
                            }}
                        >
                            <FormControl fullWidth>
                                <InputLabel id="request-select">Request For</InputLabel>
                                <Select
                                    labelId="request-select"
                                    id="request-select"
                                    value={callLimitRequestFor || ""}
                                    onChange={(e) => setCallLimitRequestFor(e?.target?.value)}
                                    label="Request For"
                                    size="small"
                                    displayEmpty
                                >
                                    {requestList.map(({ label, value }) => (
                                        <MenuItem key={label} value={value}>
                                            {label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Stack>
                    )}
                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <Stack direction={"row"} gap={1}>
                            <IconButton onClick={() => handleReset("callLimit")}>
                                <Iconify icon="ix:reset" />
                            </IconButton>
                            <LoadingButton
                                loading={callLimitLoader}
                                variant="contained"
                                sx={{ width: "100px" }}
                                onClick={() => handleSubmit("callLimit")}
                            >
                                Submit
                            </LoadingButton>
                        </Stack>
                    </Box>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        gap: "6px",
                        mb: "15px",
                        border: "0.5px dashed",
                        borderColor: "gray.400",
                        borderRadius: "7px",
                        padding: "12px",
                        paddingTop: "14px"
                    }}
                >
                    <TextField
                        fullWidth
                        id="outlined-basic"
                        label="Enter API Per Miniute Call Limit"
                        variant="outlined"
                        InputProps={{
                            sx: inputSx,
                        }}
                        value={apiPerCallLimit}
                        onChange={(e) => setApiPerCallLimit(e.target.value)}
                        size="small"
                    />
                    {user?.voiceInfo?.userType === "reseller" && (
                        <Stack
                            gap={2}
                            direction={"row"}
                            sx={{
                                justifyContent: "center",
                                alignItems: "center",
                                width: "100%",
                            }}
                        >
                            <FormControl fullWidth>
                                <InputLabel id="request-select">Request For</InputLabel>
                                <Select
                                    labelId="request-select"
                                    id="request-select"
                                    value={apiPerCallLimitRequestFor || ""}
                                    onChange={(e) => setApiPerCallLimitRequestFor(e?.target?.value)}
                                    label="Request For"
                                    size="small"
                                    displayEmpty
                                >
                                    {requestList.map(({ label, value }) => (
                                        <MenuItem key={label} value={value}>
                                            {label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Stack>
                    )}
                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <Stack direction={"row"} gap={1}>
                            <IconButton onClick={() => handleReset("apiPerCallLimit")}>
                                <Iconify icon="ix:reset" />
                            </IconButton>
                            <LoadingButton
                                loading={apiPerCallLimitLoader}
                                variant="contained"
                                sx={{ width: "100px" }}
                                onClick={() => handleSubmit("apiPerCallLimit")}
                            >
                                Submit
                            </LoadingButton>
                        </Stack>
                    </Box>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        gap: "6px",
                        mb: "15px",
                        border: "0.5px dashed",
                        borderColor: "gray.400",
                        borderRadius: "7px",
                        padding: "12px",
                        paddingTop: "14px"
                    }}
                >
                    <TextField
                        fullWidth
                        id="outlined-basic"
                        label="Regular Campaign Limit"
                        variant="outlined"
                        InputProps={{
                            sx: inputSx,
                        }}
                        value={regularCampaignLimit}
                        onChange={(e) => setRegularCampaignLimit(e.target.value)}
                        size="small"
                    />
                    {user?.voiceInfo?.userType === "reseller" && (
                        <Stack
                            gap={2}
                            direction={"row"}
                            sx={{
                                justifyContent: "center",
                                alignItems: "center",
                                width: "100%",
                            }}
                        >
                            <FormControl fullWidth>
                                <InputLabel id="request-select">Request For</InputLabel>
                                <Select
                                    labelId="request-select"
                                    id="request-select"
                                    value={regularCampaignLimitRequestFor || ""}
                                    onChange={(e) => setRegularCampaignLimitRequestFor(e?.target?.value)}
                                    label="Request For"
                                    size="small"
                                    displayEmpty
                                >
                                    {requestList.map(({ label, value }) => (
                                        <MenuItem key={label} value={value}>
                                            {label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Stack>
                    )}
                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <Stack direction={"row"} gap={1}>
                            <IconButton onClick={() => handleReset("regularCampaignLimit")}>
                                <Iconify icon="ix:reset" />
                            </IconButton>
                            <LoadingButton
                                loading={regularCampaignLimitLoader}
                                variant="contained"
                                sx={{ width: "100px" }}
                                onClick={() => handleSubmit("regularCampaignLimit")}
                            >
                                Submit
                            </LoadingButton>
                        </Stack>
                    </Box>
                </Box>
                {/* <Box
                    sx={{
                        display: "flex",
                        gap: "6px",
                        mb: "15px",
                        border: "0.5px dashed",
                        borderColor: "gray.400",
                        borderRadius: "7px",
                        padding: "12px",
                        paddingTop: "14px"
                    }}
                >
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={purgeData}
                                onChange={(e) => setPurgeData(e.target.checked)}
                                size="small"
                                sx={inputSx} // Apply your custom styles here
                            />
                        }
                        label="Purge Data"
                    />
                    {user?.voiceInfo?.userType === "reseller" && (
                        <Stack
                            gap={2}
                            direction={"row"}
                            sx={{
                                justifyContent: "center",
                                alignItems: "center",
                                width: "100%",
                            }}
                        >
                            <FormControl fullWidth>
                                <InputLabel id="request-select">Request For</InputLabel>
                                <Select
                                    labelId="request-select"
                                    id="request-select"
                                    value={purgeDataRequestFor || ""}
                                    onChange={(e) => setPurgeDataRequestFor(e?.target?.value)}
                                    label="Request For"
                                    size="small"
                                    displayEmpty
                                >
                                    {requestList.map(({ label, value }) => (
                                        <MenuItem key={label} value={value}>
                                            {label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Stack>
                    )}
                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <Stack direction={"row"} gap={1}>
                            <IconButton onClick={() => handleReset("updatePurgeData")}>
                                <Iconify icon="ix:reset" />
                            </IconButton>
                            <LoadingButton
                                loading={purgeDataCheckLoader}
                                variant="contained"
                                sx={{ width: "100px" }}
                                onClick={() => handleSubmit("updatePurgeData")}
                            >
                                Submit
                            </LoadingButton>
                        </Stack>
                    </Box>
                </Box> */}
                {/* <Box
                sx={{
                    display: "flex",
                    gap: "6px",
                    mb: "15px",
                    border: "0.5px dashed",
                    borderColor: "gray.400",
                    borderRadius:"7px",
                    padding: "12px",
                    paddingTop: "14px"
                }}
            >
                <TextField
                    fullWidth
                    id="outlined-basic"
                    label="Api Contacts Existing Customer For Cutting"
                    variant="outlined"
                    InputProps={{
                        sx: inputSx,
                    }}
                    value={apiContactExistingCustomerForCutting}
                    onChange={(e) => setApiContactExistingCustomerForCutting(e.target.value)}
                    size="small"
                />
                {user?.voiceInfo?.userType === "reseller" && (
                    <Stack
                        gap={2}
                        direction={"row"}
                        sx={{
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                        }}
                    >
                        <FormControl fullWidth>
                            <InputLabel id="request-select">Request For</InputLabel>
                            <Select
                                labelId="request-select"
                                id="request-select"
                                value={apiContactExistingCustomerForCuttingRequestFor || ""}
                                onChange={(e) => setApiContactExistingCustomerForCuttingRequestFor(e?.target?.value)}
                                label="Request For"
                                size="small"
                                displayEmpty
                            >
                                {requestList.map(({ label, value }) => (
                                    <MenuItem key={label} value={value}>
                                        {label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Stack>
                )}
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Stack direction={"row"} gap={1}>
                        <IconButton onClick={() => handleReset("apiPerCallLimit")}>
                            <Iconify icon="ix:reset" />
                        </IconButton>
                        <LoadingButton
                            loading={apiPerCallLimitLoader}
                            variant="contained"
                            sx={{ width: "100px" }}
                            onClick={() => handleSubmit("apiPerCallLimit")}
                        >
                            Submit
                        </LoadingButton>
                    </Stack>
                </Box>
            </Box> */}
            </Box>
        </>
    );
}

export default CampaignSetting